<template>
    <DialogComponent
        rejectLabel="not now"
        @cancel="onCancel"
        @continue="onContinue"
    >
        <div
            v-for="(bonus, index) in modalData.bonuses"
            :key="index"
            class="bonus__item"
        >
            {{ bonus }}
        </div>
    </DialogComponent>
</template>

<script>
    import { mapActions, mapGetters } from 'vuex';
    import { routeNames } from '@app/router';
    import DialogComponent from '../../components/DialogComponent';

    export default {
        name: 'WithdrawalBonusesThatCanExpireModal',
        computed: {
            ...mapGetters('ui/modal', [
                'modalData',
            ]),
        },
        methods: {
            ...mapActions('ui/modal', [
                'setModal',
                'closeAllModals',
            ]),
            onCancel() {
                this.$router.push({ name: routeNames.profile });
                this.closeAllModals();
            },
            onContinue() {
                this.closeAllModals();
            },
        },
        components: {
            DialogComponent,
        }
    };
</script>


// WEBPACK FOOTER //
// src/app/modals/modals/userProfile/withdrawal/WithdrawalBonusesThatCanExpireModal.vue